import React from 'react'
import { constants, links, mixpanel, snowplow } from 'common/helpers'

import Button from 'components/buttons/Button/Button'

import messages from './messages'


const UpdateToPayPalButton = ({ sm, ...rest }) => (
  <Button
    lg={!sm}
    title={messages.title}
    to={links.payPalUpdate}
    dataTestId="updateToPayPalButton"
    onClick={() => snowplow.track(constants.snowplowEvents.paypalUpdateBannerClick)}
    {...rest}
  />
)

export default UpdateToPayPalButton
